<ion-header>
  <ion-toolbar *ngIf="!bbStorage.fixedGymMode">
    <ion-buttons slot="start" data-cy="gym-name-button" (press)="gymNamePressed()" (pressup)="gymOrLogoPressReleased()">
      <ion-button [routerLink]="'/profile/'+authService.getCurrentUsername()" color="primary" fill="clear"
        routerDirection="forward">
        <ion-avatar>
          <img alt="Silhouette of a person's head" src="assets/icons/avatar.svg" />
        </ion-avatar>
      </ion-button>
      <ion-button *ngIf="activeGym" [routerLink]="'/gyms'" class="gymChooser" color="primary" fill="clear"
        routerDirection="root">
        {{activeGym.gymName}}
        <ion-spinner *ngIf="activeGymIsBeingDownloaded() || activeGymIsBeingResynced()" name="dots"></ion-spinner>
        <ion-icon name="chevron-down-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-spinner *ngIf="isBeingRefreshed" name="dots"></ion-spinner>
      <ion-button *ngIf="bbStorage.allTimeModeActive" data-cy="all-time-button" class="all-time">
        <ion-icon slot="start" name="time-outline"></ion-icon>
        all-time
      </ion-button>
      <ion-menu-button menu="boulder-list-menu"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="bbStorage.fixedGymMode" class="fixedGymModeToolbar">
    <ion-title (press)="logoPressed()" (pressup)="gymOrLogoPressReleased()" slot="start"><img
        src="assets/imgs/logo-wordmark-horizontal.png"></ion-title>
    <ion-buttons slot="end">
      <language-switcher *ngIf="bbStorage.fixedGymMode"></language-switcher>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-menu contentId="main-content" menuId="boulder-list-menu">
  <main-menu></main-menu>
</ion-menu>
<ion-content class="has-header" id="main-content">

  @if(activeGymIsBeingResynced() && bbStorage.allTimeModeActive){
  <loader [message]="'gym-sync-service.resync-gym' | translate" timeoutInSeconds="10000"></loader>
  }@else if(activeGymIsBeingResynced() || activeGymIsBeingDownloaded()){
  <loader [message]="'gym-sync-service.load-gym-data' | translate" timeoutInSeconds="10000"></loader>
  }

  @if (activeGym) {
  @if(noBoulders()) {
  @if (isBeingRefreshed){
  <loader timeoutInSeconds="1000"></loader>
  }@else {
  <div class="ion-padding">
    <logo></logo>
    <h1>{{"boulder-list-page.welcome-in" | translate}} {{activeGym?.gymName}}</h1>
    <p>{{"boulder-list-page.no-boulders" | translate}}</p>
    <p>{{"boulder-list-page.press-plus-button" | translate}}</p>
    <ion-fab horizontal="end" slot="fixed" vertical="bottom">
      <ion-fab-button color="primary" data-cy="create-boulder" [routerLink]="'/create-boulder'"
        routerDirection="forward">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </div>
  }
  } @else {
  <ion-refresher (ionRefresh)="onRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-fab horizontal="end" slot="fixed" vertical="bottom">
    <ion-fab-button color="primary" data-cy="create-boulder" [routerLink]="'/create-boulder'" routerDirection="forward">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-item class="search-mode">
    <ion-button class="search-button" *ngIf="!searchMode" (click)="searchMode=!searchMode" color="secondary"
      fill="clear">
      <ion-icon slot="start" name="search"></ion-icon>
      {{allFilteredBoulders.length}} {{(allFilteredBoulders.length > 1 ? "boulder-list-page.boulders" :
      "boulder-list-page.boulder") | translate}}
    </ion-button>
    <ion-searchbar focusSearchbar showCancelButton="always" cancelButtonText="{{'shared.cancel' | translate}}"
      (ionClear)="searchMode=false;searchString=''" *ngIf="searchMode" [(ngModel)]="searchString" color="white"
      placeholder='{{"boulder-list-page.search-boulder" | translate}}'>
    </ion-searchbar>
    <ion-button slot="end" class="filter-button" data-cy="filter-button" *ngIf="!searchMode"
      [color]="filterIsActive()?'danger':'secondary'" (click)="filterIconClicked()" fill="clear">
      <ion-icon slot="end" name="filter"></ion-icon>
      {{(filterIsActive() ? "boulder-list-page.filter-active" : "boulder-list-page.filter-and-sort") | translate}}
    </ion-button>
  </ion-item>
  @if(noFilteredBoulders()) {
  <div class="ion-padding">
    <logo></logo>
    <p>{{"boulder-list-page.no-boulders-for-filter" | translate}}</p>
    <p>{{"boulder-list-page.press-plus-button" | translate}}</p>
  </div>
  } @else {
  <ion-list [ngClass]="searchMode ? 'padding-top' : ''">
    <app-boulder-list-entry (click)="showBoulder(boulder.boulderId)"
      *ngFor="let boulder of searchString!==''?(allFilteredBoulders | boulderSearch : searchString):visibleBoulders"
      [boulder-list-entry]="boulder"></app-boulder-list-entry>
    <ion-infinite-scroll threshold="100px" (ionInfinite)="listBoulders($event)">
      <ion-infinite-scroll-content loadingSpinner="bubbles"
        loadingText='{{"boulder-list-page.load-more-boulders" | translate}}'>
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-list>
  }
  }
  } @else {
  <div class="ion-padding">
    <h1>{{"boulder-list-page.no-gym" | translate}}</h1>
    <ion-button [routerLink]="'/gyms'" color="primary" routerDirection="root">
      {{"boulder-list-page.choose-gym" | translate}}
    </ion-button>
  </div>
  }
</ion-content>
<ng-template #nogym>
</ng-template>